if ($(".datepicker").length != 0) {
    var today = new Date();

    $('.datepicker').datetimepicker({
        defaultDate: today,
        icons: {
            time: "now-ui-icons tech_watch-time",
            date: "now-ui-icons ui-1_calendar-60",
            up: "fa fa-chevron-up",
            down: "fa fa-chevron-down",
            previous: 'now-ui-icons arrows-1_minimal-left',
            next: 'now-ui-icons arrows-1_minimal-right',
            today: 'fa fa-screenshot',
            clear: 'fa fa-trash',
            close: 'fa fa-remove'
        }
    });
}

// Initiallize flatpickr
flatpickr(".js-flatpickr", {
    closeOnSelect: false,
});

var requiredLabels = document.querySelectorAll('.form-group .required');

for (i = 0; i < requiredLabels.length; ++i) {
    requiredLabels[i].classList.remove('required');
    requiredLabels[i].insertAdjacentHTML('beforeend', '<span class="required">*</span>')
}

//Handle file uploads
const fileUploadMask = document.querySelectorAll('.js-file-upload-mask');
const fileUploadInput = document.querySelectorAll('.js-file-upload-input');

if (fileUploadMask) {
    fileUploadMask.forEach(button => {
        button.addEventListener('click', evt => {
            let input = evt.target.previousElementSibling;

            if (input) {
                input.click();
            }
        });
    });
}

if (fileUploadInput) {
    fileUploadInput.forEach(input => {
        input.addEventListener('change', evt => {
            let text = evt.target.previousElementSibling;

            if (text.classList.contains('js-file-upload-text')) {
                text.innerText = evt.target.files[0].name;
            }
        });
    })
}